import React, { PropTypes } from 'react';

const propTypes = {
  image: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.string,
  content: PropTypes.node,
  header: PropTypes.string,
  meta: PropTypes.node,
  description: PropTypes.node,
};

const Item = (props) => {
  const { image, alt, size, content, header, meta, description } = props;
  const className = {
    image: `ui ${size} image`,
    content: `${content} content`,
  };

  return (
    <div className="item">
      <div className={className.image}>
        <img src={image} alt={alt} />
      </div>
      <div className={className.content}>
        <div className="header">{header}</div>
        <div className="meta">{meta}</div>
        <div className="description">{description}</div>
      </div>
    </div>
  );
};

Item.propTypes = propTypes;

export default Item;



/** WEBPACK FOOTER **
 ** ./src/components/layout/sui/item/Item.js
 **/